// Some entry links are bound to a specific identity: an org invitation is
// addressed to one email, and the waitlist-approval email ("Finish setup")
// unlocks exactly the signup that was approved. When such a link lands on
// /login or /signup with ?email=, the address is locked so the user can't
// drift onto a different account and wonder why nothing happened.
//
// Returns why the address is locked (drives the helper copy under the
// field), or null when the email is a plain, editable prefill.
export type LockedEmailReason = "invite" | "setup";

export function lockedEmailReason(
  next: string | undefined,
  email: string | undefined,
): LockedEmailReason | null {
  if (!email) return null;
  if (next?.startsWith("/accept-invitation/")) return "invite";
  if (next === "/onboarding") return "setup";
  return null;
}

export const LOCKED_EMAIL_COPY: Record<LockedEmailReason, string> = {
  invite: "This invitation was sent to this email address.",
  setup: "Your approval was sent to this email address — sign in with it to finish setup.",
};
